import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

type Props = {
    className?: string;
    title: React.ReactNode;
};

const PageTitle = ({ className, title }: Props) => {
    if (!title) {
        return null;
    }
    return <StyledTextH1 className={className}>{title}</StyledTextH1>;
};

export default React.memo<Props>(PageTitle, isEqual);

const StyledTextH1 = styled.h1`
    && {
        display: block;
        margin: 30px auto 20px;
    }
`;
